export default __webpack_public_path__ + "static/media/m_quiz_bg.499ef8c8.png";